import { IWizardCol } from './../../wizard/wizard-col.component';
import { WizardService } from './../../wizard/wizard.service';

export const step1: IWizardCol = {
  title: 'sessions.create.wizard.step1.title',
  isFirst: true,
  subscription: new WizardService().getPrivacySubscription(),
  cols: [
    {
      title: 'sessions.create.wizard.step1.public_access.title',
      option: 'public',
      icon: 'eye',
      description: [
        'sessions.create.wizard.step1.public_access.free_access',
        'sessions.create.wizard.step1.public_access.login_form',
        'sessions.create.wizard.step1.public_access.social_auth'
      ]
    },
    {
      title: 'sessions.create.wizard.step1.private_access.title',
      option: 'private',
      icon: 'user-secret',
      description: [
        'sessions.create.wizard.step1.private_access.mail',
        'sessions.create.wizard.step1.private_access.generic_login'
      ]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/app/modules/sessions/create/step/step1.ts